import React from 'react';
import './PostulacionCompletada.css';

const PostulacionCompletada: React.FC = () => {
  return (
    <div className="postulacion-completada">
      <div className="completada-card">
        <div className="success-icon">✓</div>
        <h1>¡Postulación Completada!</h1>
        <p>
          Su postulación ha sido enviada exitosamente. 
          Nuestro equipo la revisará y se pondrá en contacto con usted a la brevedad posible.
        </p>
        <div className="info-box">
          <h3>Próximos pasos:</h3>
          <ul>
            <li>Su información será revisada por nuestro equipo</li>
            <li>Recibirá una notificación por correo electrónico sobre el estado de su postulación</li>
            <li>Si es aprobada, será contactado para continuar con el proceso</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PostulacionCompletada;

